// Share activity signals without using localStorage or persisting tokens.
const KEY = "lastUserActivityAt";
const CHANNEL = "odp-activity-session-v1";
const channel = typeof BroadcastChannel !== "undefined" ? new BroadcastChannel(CHANNEL) : null;
let latest = 0;
const listeners = new Set<(timestamp: number) => void>();

const accept = (timestamp: number) => {
  if (!Number.isFinite(timestamp) || timestamp <= latest || timestamp > Date.now() + 5000) return;
  latest = timestamp;
  sessionStorage.setItem(KEY, String(timestamp));
  listeners.forEach((listener) => listener(timestamp));
};

if (channel) {
  channel.onmessage = (event: MessageEvent) => {
    if (event.data?.type === "activity" && typeof event.data.timestamp === "number") {
      accept(event.data.timestamp);
    }
  };
}

export const readCrossTabActivity = (): number | null => {
  const stored = Number(sessionStorage.getItem(KEY));
  return Math.max(latest, Number.isFinite(stored) ? stored : 0) || null;
};

let lastBroadcast = 0;
export const writeCrossTabActivity = (timestamp: number): void => {
  if (!Number.isFinite(timestamp)) return;
  accept(timestamp);
  if (channel && timestamp - lastBroadcast >= 1000) {
    lastBroadcast = timestamp;
    channel.postMessage({ type: "activity", timestamp });
  }
};

export const subscribeCrossTabActivity = (listener: (timestamp: number) => void): (() => void) => {
  listeners.add(listener);
  return () => { listeners.delete(listener); };
};
